/* istanbul ignore file */
const ACCESS_TOKEN_KEY = 'bl_token';
const ACCESS_TOKEN_KEY_DEV = 'bl_token_dev';
const ACCESS_TOKEN_KEY_TEST = 'bl_token_test';

function tokenStorageLabel() {
  const { env } = window.APP;
  if (env === 'development') {
    return ACCESS_TOKEN_KEY_DEV;
  }
  if (env === 'staging') {
    return ACCESS_TOKEN_KEY_TEST;
  }

  return ACCESS_TOKEN_KEY;
}

export default function getToken() {
  return window.localStorage.getItem(tokenStorageLabel());
}
